export const LOAD_FORMS = 'LOAD_FORMS';
export const NEW_FORM = 'NEW_FORM';
export const UPDATE_NEW_FORM = 'UPDATE_NEW_FORM';
export const SELECTED_FORM = 'SELECTED_FORM';
export const RESET_NEW_FORM = 'RESET_NEW_FORM';
export const RESET_SELECTED_FORM = 'RESET_SELECTED_FORM';
export const LOADING_START = 'LOADING_START';
export const LOADING_DONE = 'LOADING_DONE';
